import cn from '@/lib/clsxm';
import { addZeroIfUnder10 } from '@/lib/helper';
import { useTimer } from 'react-timer-hook';
import { useEffect } from 'react';
import { addToTime } from '@/lib/date';
import useOTPAuthStore from '@/store/otp-auth-store';
import ICON_SIZE from '@/constant/icon-size-color';
import { Timer1 } from 'iconsax-react';
import useHomeStore from '@/store/home';
import Skeleton from '@/components/@base/skeleton';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { SIZE_ENUM } from '@/components/@base/@types';
import useCommonModalStore from '@/store/common-modal-store';
import PaymentTimeExpiration from '@/components/payment-time-expiration';

const Timer = () => {
  const { paymentTime, setPaymentTime } = useOTPAuthStore();
  const { setTimerExpired, expiredAt, timerExpired } = useHomeStore();
  const { setShow } = useCommonModalStore()
  const { minutes, seconds, restart } = useTimer({
    expiryTimestamp: paymentTime || new Date(new Date().getTime() + 50000),
    onExpire: () => {
      setTimerExpired(true);
      localStorage.getItem('expiredAt') && showTimeExpireModal()
    },
  });
  const showTimeExpireModal = () => {
    expiredAt && localStorage.getItem('expiredAt') && setShow(true, {
      onDemandClose: false,
      grayScaleBackDrop: true,
      dialogPanelClassName: 'p-0 w-[85%] md:w-[380px]',
      center:true,
      Body: () => <PaymentTimeExpiration/>
    })
  }
  useEffect(() => {
    if(expiredAt) {
      const time = addToTime(new Date(), expiredAt, { unit: 'SECONDS' });
      restart(time);
      setPaymentTime(time);
    }
  }, [expiredAt]);
  return (
    <Container
      center
      className='min-w-[60px] rounded-full bg-white px-2 py-1 dark:bg-grayLight-990 h-full'
    >
      {(!expiredAt && !timerExpired) ? (
        <Skeleton
          className='w-10 bg-grayLight-100/10 dark:bg-grayLight-800/80'
          baseColor={'bg-grayLight-800/30'}
        />
      ) : (
        <Text medium size={SIZE_ENUM.MD} className={cn('text-grayLight-800 dark:text-white mt-1')}>
          {`${addZeroIfUnder10(minutes)}:${addZeroIfUnder10(seconds)}`}
        </Text>
      )}
    </Container>
  );
};

export default Timer;
